export default __webpack_public_path__ + "static/media/pub_gastronomie.3ba55c84.jpg";